import React from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from '@/context/auth';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './index.css';

// Register Service Worker
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then(registration => {
        console.log('SW registered:', registration);

        // Request notification permission after SW registration
        if ('Notification' in window) {
          Notification.requestPermission();
        }

        // Register for periodic sync if supported
        if ('periodicSync' in registration) {
          const periodicSync = registration.periodicSync as any;
          periodicSync.register('update-recipes', {
            minInterval: 24 * 60 * 60 * 1000 // 24 hours
          });
        }
      })
      .catch(registrationError => {
        console.log('SW registration failed:', registrationError);
      });
  });
}

const root = createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <Toaster position="top-right" />
      <App />
    </AuthProvider>
  </React.StrictMode>
);